import {RemoteGetDenialLetter} from 'data/usecases/private/authorizations';
import {GetDenialLetter} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {AuthorizationsFlowEndpoints} from '../../endpoints';

export const makeGetDenialLetter = (): GetDenialLetter =>
	new RemoteGetDenialLetter(
		makeBFFApiUrl(AuthorizationsFlowEndpoints.denialLetter),
		makeAuthorizeHttpClientDecorator(),
	);
